import packageJson from '../../../../package.json';
import { AllocationImplementation } from '../app/shared/models/allocation-implementation.enum';
import { AllocationMethod } from '../app/shared/models/allocation-method.enum';
import { DefaultMetricsGroup } from '../app/shared/models/default-metrics-group.enum';


export const environment: {
    appName: string;
    test: boolean;
    debug: boolean;
    apiUrl: string;
    production: boolean;
    attributes: boolean;
    listingPagination: boolean;
    envName: string;
    version: string;
    userManagementApiUrl: string;
    pictureManagerApiUrl: string;
    awsCognitoIdentityPoolId: string;
    awsUserPoolsId: string;
    awsUserPoolsWebClientId: string;
    awsOAuthDomain: string;
    awsOAuthRedirectSignIn: string;
    awsOAuthRedirectSignOut: string;
    awsOAuthScopes: Array<string>;
    pictureManagerCloudfrontDistribution: string;
    packlotEnabled: boolean;
    /**
     * Description for stylingMetricsSplit
     *
     * Default: false
     * BRD: true
     *
     * When stylingMetricsSplit is true, the getSizeValue function, in the styling component, splits the string
     * and returns the number.
     * Associated code: return Number(String(item[size]).split('|')[0]);
     *
     * When stylingMetricsSplit is false, the getSizeValue function, in the styling component, just returns the item size.
     * Associated code: return item[size];
     */
    stylingMetricsSplit: boolean;

    /**
     * Description for stylingExcludeStoreNumber
     *
     * Default: false
     * BRD: true
     *
     * When stylingExcludeStoreNumber is set to true, the getStoreName function, in the styling component, returns the
     * store name WITHOUT the brackets and id.
     * Associated code: return item.store_name.substr(0, item.store_name.indexOf('(')).trim();
     *
     * When stylingExcludeStoreNumber is set to false, the getStoreName function, in the styling component, returns the
     * store name WITH the brackets and id.
     * Associated code: return item.store_name.substr(item.store_name.indexOf(')') + 2).trim();
     */
    stylingExcludeStoreNumber: boolean;

    /**
     * Description for allocationMethod
     *
     * Duns: ExactMl
     * BRD: ExactAlgo
     * Default: ExactAlgo
     *
     * This dictates the allocation method used in the determineAllocationColumn, in the workbench table component.
     * Associated code: return `allocated_${environment.allocationMethod}_${data.weeks_of_cover}wk_sls_u`;
     *                  return `allocated_${environment.allocationMethod}_${parameters.weeksOfCover}wk_sls_u`;
     *                  return 'allocated_${environment.allocationMethod}_${environment.allocationMethodNumberOfWeeks}wk_sls_u';
     */
    allocationMethod: AllocationMethod;

    /**
     * Description for allocationDefaultNumberOfWeeks
     *
     * Default: 8
     *
     * This dictates the number of weeks for the allocation method used in the determineAllocationColumn, in the workbench table component.
     * Associated code: return 'allocated_${environment.allocationMethod}_${environment.allocationMethodNumberOfWeeks}wk_sls_u';
     */
    allocationDefaultNumberOfWeeks: number;
    defaultMetricsGroup: DefaultMetricsGroup;
    canCreateAllocations: boolean;
    nextFrontendUrl: string;
    expansiveWeeksOfCover: boolean;
    allocationFlushOutNumberOfWeeks: number;
    allocationHasFlushOut: boolean;
    onlyHasAllocations: boolean;
    useBrandivioBranding: boolean;
    allowSso: boolean;
    useWWAlternateFilterDisplayNames: boolean;
    usePnPAlternateFilterDisplayNames: boolean;
    hideAnalyticsFiltersErrors: boolean;
    allowAllocationCompleteAll: boolean;
    allowFileIntegrationCompleteManually: boolean;
    allowFileIntegrationRejectManually: boolean;
    allowSyncStartedManually: boolean;
    excludeZeroWeeksOfCover: boolean;
    AllocationImplementation: AllocationImplementation;
    allowGlobalWocOverride: boolean;
    stylingExportFormat: 'xlsx' | 'csv';
} = {
    appName: 'Lynkd Pattern Analytics',
    envName: 'PROD',
    debug: false,
    production: true,
    test: false,
    attributes: true,
    listingPagination: false,
    version: packageJson.version,
    apiUrl: 'https://ttown-uat-wl.patternretail.com/app',
    userManagementApiUrl: 'https://ttown-uat-um.patternretail.com',
    pictureManagerApiUrl: 'https://ttown-uat-wl.patternretail.com/app/api/picture-manager',
    awsCognitoIdentityPoolId: 'eu-west-1:5173fc44-4283-494f-94d7-fc34c27204e9',
    awsUserPoolsId: 'eu-west-1_pryvpZAiR',
    awsUserPoolsWebClientId: '3b0lprd97loi4uijdpe13cfs7h',
    pictureManagerCloudfrontDistribution: 'https://ttown-uat-cdn.patternretail.com',
    awsOAuthDomain: '',
    awsOAuthRedirectSignIn: '',
    awsOAuthRedirectSignOut: '',
    awsOAuthScopes: [],
    packlotEnabled: false,
    stylingMetricsSplit: true,
    stylingExcludeStoreNumber: false,
    allocationMethod: AllocationMethod.ExactAlgo,
    allocationDefaultNumberOfWeeks: 0,
    defaultMetricsGroup: DefaultMetricsGroup.Algo,
    canCreateAllocations: true,
    nextFrontendUrl: '',
    expansiveWeeksOfCover: true,
    allocationFlushOutNumberOfWeeks: 48,
    allocationHasFlushOut: true,
    onlyHasAllocations: false,
    useBrandivioBranding: false,
    allowSso: false,
    usePnPAlternateFilterDisplayNames: false,
    useWWAlternateFilterDisplayNames: false,
    hideAnalyticsFiltersErrors: true,
    allowAllocationCompleteAll: true,
    allowFileIntegrationCompleteManually: true,
    allowFileIntegrationRejectManually: true,
    allowSyncStartedManually: false,
    excludeZeroWeeksOfCover: false,
    AllocationImplementation: AllocationImplementation.Manual,
    allowGlobalWocOverride: false,
    stylingExportFormat: 'xlsx'
};
